import { render, staticRenderFns } from "./workSpace.vue?vue&type=template&id=221923fb&scoped=true&lang=html&"
import script from "./workSpace.vue?vue&type=script&lang=js&"
export * from "./workSpace.vue?vue&type=script&lang=js&"
import style0 from "./workSpace.vue?vue&type=style&index=0&id=221923fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221923fb",
  null
  
)

component.options.__file = "workSpace.vue"
export default component.exports